import axios from 'axios'
import NProgress from 'nprogress'

export const API_URL = process.env.VUE_APP_STRAPI_BASE_URL ?? 'https://admin.melbournemalibu.com.au/api'

export const Axios = axios.create({
    baseURL: API_URL
})

// Refer to NProgress documentation to utilise NProgress

// before a request is made start the nprogress
Axios.interceptors.request.use(config => {
    NProgress.start()
    NProgress.inc()
    return config
})

// before a response is returned stop nprogress
Axios.interceptors.response.use(
    response => {
        NProgress.done()
        return response
    },
    error => {
        NProgress.done()
        return error
    })
